<template>
    <button
        ref="button"
        type="button"
        :disabled="!userCanParticipate"
        class="button"
        @click="onClick"
    >
        <partner-logo :class="['logo', { 'logo--height': isSelectorSheet }]"
            :show-placeholder="!src"
            :url="src"
        />

        <div class="icon-wrapper">
            <span v-if="(userHasParticipated || userCanParticipate) || (isSelected && alternativeColor)"
                :class="['icon feature-icon', {
                    'feature-icon--selected': (isSelected && !alternativeColor),
                }, alternativeColorClasses]"
            >
                <i :class="['icon', icon]" />
            </span>
        </div>
    </button>
</template>

<script>
import partnerLogo from '@webapp/components/partner-logo/partner-logo.vue';

export default {
    name: 'team-button',
    components: {
        partnerLogo,
    },
    props: {
        src: {
            type: [String, Boolean],
            default: null,
        },
        isSelected: {
            type: Boolean,
            required: true,
        },
        // Team button is used for: football check in, american football check in, american football prediction
        userHasParticipated: {
            type: Boolean,
            required: true,
        },
        // Team button is used for: football check in, american football check in, american football prediction
        userCanParticipate: {
            type: Boolean,
            required: true,
        },
        // Change the icon based on the action - check-in (both American Football & Football) or prediction (American Football only)
        type: {
            type: String,
            default: 'checkIn',
            validator(value) {
                return ['checkIn', 'predict'].includes(value);
            },
        },
        // Reuse the component on the predictor screen after predicting
        alternativeColor: {
            type: String,
            default: '',
        },
        isSelectorSheet: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        icon() {
            if (this.type === 'predict') {
                return 'icon-crown-circle';
            }

            return '';
        },

        alternativeColorClasses() {
            return this.alternativeColor ? `feature-icon--alternative-color feature-icon--alternative-color-${this.alternativeColor}` : '';
        },
    },
    methods: {
        onClick() {
            if (!this.userCanParticipate || this.userHasParticipated || this.isSelected || this.alternativeColor) {
                return;
            }

            this.$emit('tap');
        },
    },
};
</script>

<style lang="scss" scoped>
.button {
    display: block;
    position: relative;
    background: none;
    text-align: right;

    &:disabled,
    &--disabled {
        opacity: 1;
    }
}

.logo {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;

    &--height {
        height: 80px;
    }
}

.icon-wrapper {
    position: absolute;
    right: 5px;
    bottom: 0;
    // Needs to be above the logo
    z-index: 3;
}

.feature-icon {
    font-size: 30px;
    color: $silver-chalice-color;
    background: $white-color;
    border-radius: 50%;
    border-width: 1px;
    border-color: $silver-chalice-color;

    &--selected {
        color: $white-color;
        background: $lima-color;
    }

    &--alternative-color {
        color: $white-color;
        background-color: $silver-chalice-color;

        &-red {
            background-color: $torch-red-color;
        }

        &-green {
            background-color: $lime-green-color;
        }
    }
}
</style>